import { createRoot } from 'react-dom/client';
import { InstallPage } from '../pages/InstallPage';

createRoot(document.getElementById('root')!).render(<InstallPage {...window.__PAGE_PROPS__} />);
